// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__T6QHL","wrapper":"MainPage_wrapper__MG9Ow"};